/**
 *
 * @param {value, record and column} props
 * @returns "Table Cell with Class"
 */
import axios from "axios";
import { useState } from "react";
import { Modal, Spin, Switch, Button, Table, message, Form, Input } from "antd";
import { FormattedNumberCell } from "../../../Utils/helpers/formatting";
import { FaPencilAlt } from "react-icons/fa";
import Config from "../../../Config";
import { useDispatch, useSelector } from "react-redux";
import { getDataTable } from "../../../Redux/Actions/Thunk/dataTableThunk";
import DataTableClient from "../DataTableClient/DataTableClient";
import { formDataAppend } from "../../../Utils/helpers";

const ServiceCell = ({ value, record, column, cellClass, extraParams }) => {
  const {
    API_BI: { baseURL },
  } = Config;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const openChart = (props) => {
    setIsModalOpen(true);
  };

  var sourceName = record?.source_title;
  var jobName = record?.job_name;

  const handleSubmit = async (values) => {
    console.log(record);
    let job_id = record?.job_id;
    setLoading(true);
    try {
      const graphqlEndpoint = baseURL + "graphql";
      const query = `
        mutation UpdateWithVariables($etlMetadataId: Int!, $reasonForReprocess: String!) {
          update(etlMetadataId: $etlMetadataId, reasonForReprocess: $reasonForReprocess) {
            resultList {
              reasonForReprocess
              userId
            }
            message
            success
          }
        }
      `;

      const variables = {
        etlMetadataId: job_id,
        reasonForReprocess: values?.reasonForReprocess,
      };
      let filteredData = extraParams?.all_input_data;
      let formDatafilter = formDataAppend(filteredData);

      const response = await axios.post(
        graphqlEndpoint,
        { query, variables },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      const { success, message: apiMessage } = response.data.data.update;

      if (success) {
        message.success(apiMessage || "Reprocess triggered successfully!");
        dispatch(getDataTable(formDatafilter, { block: extraParams?.block }));
        handleCancel();
      } else {
        message.error(apiMessage || "Failed to reprocess.");
      }
    } catch (error) {
      // console.error("API call error:", error);
      message.error("Something went wrong.");
    } finally {
      setLoading(false);
      setFormVisible(false);
      form.resetFields();
    }
  };

  const columns = [
    {
      dataIndex: "reflection_name",
      title: <strong>Reflection Name</strong>,
      key: "reflection_name",
      sorter: false,
    },
    {
      dataIndex: "error_message",
      title: <strong>Failure Message</strong>,
      key: "error_message",
      sorter: false,
      filter: false,
    },
  ];

  return (
    <>
      <div>
        <span className={cellClass}>
          <FormattedNumberCell value={value} format={column} />
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;
          <FaPencilAlt
            style={{ cursor: "pointer" }}
            onClick={() => openChart(value)}
          />
        </span>

        {isModalOpen && (
          <Modal
            className="impact-modals"
            title={
              <span>
                <strong>Source:</strong> {sourceName}
                <br />
                <br />
                <strong>Job Name:</strong> {jobName}
              </span>
            }
            visible={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            width="80%"
            footer={null}
          >
            <>
              <Table
                dataSource={record?.failed_list}
                columns={columns}
                scroll={{ x: 400 }}
                pagination={{
                  showSizeChanger: false,
                }}
              />

              <div style={{ marginTop: 16, textAlign: "right" }}>
                {!formVisible ? (
                  <Button
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      borderColor: "green",
                    }}
                    onClick={() => setFormVisible(true)}
                  >
                    Reprocess Job
                  </Button>
                ) : (
                  <Form
                    form={form}
                    onFinish={handleSubmit}
                    layout="vertical"
                    style={{ marginTop: 24 }}
                  >
                    <Form.Item
                      name="reasonForReprocess"
                      label="Reason for Reprocess"
                      rules={[
                        { required: true, message: "Please enter a reason" },
                      ]}
                    >
                      <Input.TextArea rows={4} placeholder="Enter reason..." />
                    </Form.Item>

                    <Form.Item style={{ textAlign: "right" }}>
                      <Button
                        onClick={() => setFormVisible(false)}
                        style={{ marginRight: 8 }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        // loading={loading}
                        style={{
                          backgroundColor: "green",
                          borderColor: "green",
                        }}
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                )}
              </div>
            </>
          </Modal>
        )}
      </div>
    </>
  );
};

const ServiceHealthDashboard = (props) => {
  // console.log(props);
  const columnIds = [
    "pull_status",
    "etl_status",
    "ems_status",
    "overall_status",
  ];
  let cellClass = "";
  if (columnIds.includes(props.column.dataIndex)) {
    if (props.value == "Failed" || props.value == "Not Completed") {
      cellClass = "light-red-column";
    }
    if (props.value == "Passed" || props.value == "Completed") {
      cellClass = "light-green-column";
    }
    if (props.value == "In Progress") {
      cellClass = "light-yellow-column";
    }
  }
  if (props.column.dataIndex === "ems_status" && props.value === "Failed") {
    return <ServiceCell {...props} cellClass={cellClass} />;
  }
  return (
    <span className={cellClass}>
      <FormattedNumberCell value={props.value} format={props.column.format} />
    </span>
  );
};

export default ServiceHealthDashboard;
